import { Route } from "wouter";
import { TierPage } from "@/components/ui/tier-page";

// Employer portal pages
import Dashboard from "@/pages/employer/Dashboard";
import CompanyProfile from "@/pages/employer/CompanyProfile";
import Employees from "@/pages/employer/Employees";
import EmployeeDetails from "@/pages/employer/EmployeeDetails";
import Payroll from "@/pages/employer/Payroll";
import Contractors from "@/pages/employer/Contractors";
import Benefits from "@/pages/employer/Benefits";
import Compliance from "@/pages/employer/Compliance";
import COBRADetails from "@/pages/employer/COBRADetails";
import HIPAADetails from "@/pages/employer/HIPAADetails";
import ERISADetails from "@/pages/employer/ERISADetails";
import EligibilityMilestones from "@/pages/employer/EligibilityMilestones";
import HR from "@/pages/employer/HR";
import Documents from "@/pages/employer/Documents";
import Reports from "@/pages/employer/Reports";
import { ACAModule } from "@/pages/employer/aca";
import Settings from "@/pages/broker/Settings";

// Time Off module pages
import TimeOffOverview from "@/pages/employer/timeoff/Overview";
import TimeOffRequests from "@/pages/employer/timeoff/Requests";
import TimeOffPolicies from "@/pages/employer/timeoff/Policies";
import TimeOffBalances from "@/pages/employer/timeoff/Balances";
import TimeOffSettings from "@/pages/employer/timeoff/Settings";
import TimeOffCalendar from "@/pages/employer/timeoff/Calendar";
import TimeOffHolidays from "@/pages/employer/timeoff/Holidays";

export const EmployerDashboard = Dashboard;

const TierProtectedCompliance = () => (
  <TierPage feature="benefits_compliance_wizard" pageTitle="Benefits Compliance Wizard">
    <Compliance />
  </TierPage>
);

const TierProtectedCOBRADetails = () => (
  <TierPage feature="benefits_compliance_wizard" pageTitle="Benefits Compliance Wizard">
    <COBRADetails />
  </TierPage>
);

const TierProtectedHIPAADetails = () => (
  <TierPage feature="benefits_compliance_wizard" pageTitle="Benefits Compliance Wizard">
    <HIPAADetails />
  </TierPage>
);

const TierProtectedERISADetails = () => (
  <TierPage feature="benefits_compliance_wizard" pageTitle="Benefits Compliance Wizard">
    <ERISADetails />
  </TierPage>
);

const TierProtectedHR = () => (
  <TierPage feature="hr_compliance_overview" pageTitle="HR Compliance Overview">
    <HR />
  </TierPage>
);

export function EmployerRoutes() {
  return (
    <>
      <Route path="/company" component={CompanyProfile} />
      <Route path="/employees" component={Employees} />
      <Route path="/employees/:id" component={EmployeeDetails} />
      <Route path="/payroll" component={Payroll} />
      <Route path="/contractors" component={Contractors} />
      <Route path="/benefits" component={Benefits} />
      <Route path="/compliance" component={TierProtectedCompliance} />
      <Route path="/compliance/cobra-details" component={TierProtectedCOBRADetails} />
      <Route path="/compliance/hipaa-details" component={TierProtectedHIPAADetails} />
      <Route path="/compliance/erisa-details" component={TierProtectedERISADetails} />
      <Route path="/eligibility-milestones" component={EligibilityMilestones} />
      <Route path="/aca">{() => <ACAModule />}</Route>
      <Route path="/hr" component={TierProtectedHR} />
      <Route path="/documents" component={Documents} />
      <Route path="/reports" component={Reports} />
      <Route path="/settings" component={Settings} />

      {/* Time Off Module - both path styles for navigation flexibility */}
      <Route path="/time-off" component={TimeOffOverview} />
      <Route path="/time-off/requests" component={TimeOffRequests} />
      <Route path="/time-off/policies" component={TimeOffPolicies} />
      <Route path="/time-off/balances" component={TimeOffBalances} />
      <Route path="/time-off/settings" component={TimeOffSettings} />
      <Route path="/time-off/calendar" component={TimeOffCalendar} />
      <Route path="/time-off/holidays" component={TimeOffHolidays} />
      <Route path="/employer/time-off" component={TimeOffOverview} />
      <Route path="/employer/time-off/requests" component={TimeOffRequests} />
      <Route path="/employer/time-off/policies" component={TimeOffPolicies} />
      <Route path="/employer/time-off/balances" component={TimeOffBalances} />
      <Route path="/employer/time-off/settings" component={TimeOffSettings} />
      <Route path="/employer/time-off/calendar" component={TimeOffCalendar} />
      <Route path="/employer/time-off/holidays" component={TimeOffHolidays} />
    </>
  );
}
